import axios from "axios"


axios.interceptors.request.use(
    function (config) {
        config.headers['X-SS-API-KEY']= process.env.VUE_APP_API_VALUE;
    // config.headers['Content-Type'] = 'application/json';
    //也可以这种写法
    // config.headers['accessToken'] = Token;
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export default axios